export default {
    NO_DATE: 'nodate',
    Date: 'date'
};
